import ShortUniqueId from "short-unique-id";

/** Convenience function to generate a short unique id */
export const createShortId: ShortUniqueId = new ShortUniqueId();
